export default __webpack_public_path__ + "static/media/Helm of the Shivering Stars.0457bc4e.jpg";